// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2CX28","alertIcon":"ConfirmModal_alertIcon__1BcQH"};